import React from "react";
import { ThemeProvider } from "./src/context/ThemeContext";

export const shouldUpdateScroll = ({
  routerProps: { location },
  prevRouterProps,
}) => {
  // 페이지 경로가 변경되었을 경우에만 스크롤을 맨 위로 이동
  if (
    prevRouterProps &&
    location.pathname !== prevRouterProps.location.pathname
  ) {
    return [0, 0];
  }

  return true; // 나머지 경우에는 Gatsby의 기본 스크롤 동작을 허용
};

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
);
